import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { cmsService } from '@/services/'
import moment from './helpers/moment.js'
import dialogBase from '@/components/common/Dialog/dialogBase.js'

Vue.prototype.$cmsService = cmsService
Vue.mixin(moment)

Vue.config.productionTip = false
// Variables passed by server
Vue.prototype.config = window.config

new Vue({
  router,
  store,
  vuetify,
  dialogBase,
  render: h => h(App)
}).$mount('#app')
